import { z } from 'zod';

import { PersistableProfile } from './PersistableProfile';

interface PersistableProfileRepo {
  profiles: PersistableProfile[];
  orgAdminProfiles: PersistableProfile[];
  disabledProfiles: PersistableProfile[];
}

const PersistableProfileRepo = z.object({
  profiles: z.array(PersistableProfile),
  orgAdminProfiles: z.array(PersistableProfile).default([]),
  disabledProfiles: z.array(PersistableProfile).default([]),
});

export { PersistableProfileRepo };
